import { useFormContext } from 'react-hook-form';
import { useI18n } from '@react/i18n';
import { CheckoutFormValues } from '../types';

/** Poznámka k objednávce. */
export default function NoteSection() {
    const t = useI18n();
    const { register } = useFormContext<CheckoutFormValues>();

    return (
        <fieldset>
            <div className="b-note">
                <p className="basket__title">{t('Poznámka')}</p>
                <div className="form-group">
                    <textarea className="form-control" {...register('note')} />
                </div>
            </div>
        </fieldset>
    );
}
